import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {EmailConfirmationComponent} from './email-confirmation.component';

const routes: Routes = [
  {path: 'email-confirmation', component: EmailConfirmationComponent},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})
export class EmailConfirmationRoutingModule { }
